import { render, staticRenderFns } from "./SimpleUpload.vue?vue&type=template&id=61b2266f&scoped=true&"
import script from "./SimpleUpload.vue?vue&type=script&lang=js&"
export * from "./SimpleUpload.vue?vue&type=script&lang=js&"
import style0 from "./SimpleUpload.vue?vue&type=style&index=0&id=61b2266f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b2266f",
  null
  
)

export default component.exports